import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LogoutUseCase } from '@modules/auth';
import { DialogCloseTokenComponent } from '@shared/components/dialog-close-token/dialog-close-token.component';

@Injectable({
  providedIn: 'root',
})
export class AuthLogoutService {
  constructor(
    private readonly dialog: MatDialog,
    private readonly logoutUseCase: LogoutUseCase,
  ) {}

  showExpiredDialogAndLogout() {
    const dialogRef = this.dialog.open(DialogCloseTokenComponent, {
      disableClose: true,
      width: '500px',
    });

    setTimeout(() => {
      dialogRef.close();
      this.logoutUseCase.execute().subscribe();
    }, 5000);
  }
}
